import styled from '@emotion/styled';
import { forwardRef } from 'react';

import { animationFade } from '../../theme/animations/animationFade';
import { animationScaleFade2 } from '../../theme/animations/animationScaleFade';
import { cssUtil } from '../../theme/cssUtil';
import { su } from '../../theme/functions/su';
import { motion } from '../../theme/motion';

export function FlowFlex() {}

FlowFlex.Root = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const FlowFlexItemBase = styled.div`
  flex: 0 0 auto;
  padding-inline-end: ${su(2)};
  padding-bottom: ${su(2)};

  &:not([data-animated='true']) {
    opacity: 0;
    animation-name: ${animationScaleFade2.in};
    animation-duration: ${motion.duration.slow};
    animation-timing-function: ease-in-out;
    animation-fill-mode: forwards;
    animation-iteration-count: 1;
    animation-delay: var(--animation-delay);

    ${cssUtil.isReducedMotion} {
      opacity: 1;
      animation-name: ${animationFade.in};
      animation-delay: initial;
    }
  }
`;

function handleFlowFlexItemAnimationEnd(event) {
  event.currentTarget.setAttribute('data-animated', 'true');
}

FlowFlex.Item = forwardRef(function FlowFlexItem(
  { onAnimationEnd = handleFlowFlexItemAnimationEnd, ...props },
  ref,
) {
  return <FlowFlexItemBase ref={ref} onAnimationEnd={onAnimationEnd} {...props} />;
});
